import * as yup from "yup";

export const createCountrySchema = (v, t, isEditMode) => {
  return yup.object().shape({
    name: v.string().required(),
    nameEn: v.string().required(),
    order: yup.number()
    .min(1, t("mustBePositiveNumber"))
    .typeError(t("mustBeANumber"))
    .required(),
  });
};
